import React from 'react';
import { FormItem, Input } from 'formik-antd';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { SubpartnersRegisterSelect } from 'common/components/SubpartnersSelect';
import { useRole } from 'common/hooks/useRole';
import { isNil } from 'ramda';
import { BusinessPartnerContext } from 'pages/BusinessPartnerManagement/BusinessPartnerContext';
import { useEnsureContext } from 'common/hooks';

export const BusinessPartnerProfileOwnerFormItems = () => {
  const intlMessage = useFormatMessage();
  const { isMedicalOperator } = useRole();
  const bpContext = useEnsureContext(BusinessPartnerContext);

  const shouldHidePartnerDropdown =
    !isNil(bpContext.parentPartnerId) || isMedicalOperator;

  return (
    <>
      <FormItem
        label={intlMessage({ id: 'person.firstName' })}
        name="firstName"
        required
      >
        <Input name="firstName" />
      </FormItem>

      <FormItem
        label={intlMessage({ id: 'person.lastName' })}
        name="lastName"
        required
      >
        <Input name="lastName" />
      </FormItem>

      <FormItem label={intlMessage({ id: 'email' })} name="email" required>
        <Input name="email" />
      </FormItem>

      {!shouldHidePartnerDropdown && (
        <FormItem label={intlMessage({ id: 'partner' })} name="partner">
          <SubpartnersRegisterSelect name="partner" />
        </FormItem>
      )}
    </>
  );
};
